import React, { useEffect } from 'react'

function AddClientEnvironment({ sendDataToParent, onLoad }) {

  function handleChange(e) {
    const { name, value } = e.currentTarget;
    sendDataToParent((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }

  useEffect(() => {
    onLoad(undefined);
  }, []);

  return (
    <>
      <div className="row">
        <div className="mb-3">
          <label className="form-label">
            Client Name<span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="Name"
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">
            Client Url<span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="ClientUrl"
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">
            API Url<span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="APIUrl"
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">
            Branch<span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="BranchName"
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">
            Database<span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="DatabaseName"
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">
            Favicon Path<span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="FaviconPath"
            onChange={handleChange}
          />
        </div>
      </div>
    </>
  )
}

export default AddClientEnvironment